import React, { useState, useEffect } from 'react';
import { 
  User, 
  Upload, 
  Save, 
  Edit3, 
  FileText, 
  Calendar,
  Phone,
  Mail,
  MapPin,
  Briefcase,
  Clock,
  CheckCircle,
  XCircle,
  AlertCircle,
  Download,
  Eye,
  Plus,
  Trash2
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { dbHelpers } from '../config/database';

interface Document {
  id: string;
  name: string;
  type: 'resume' | 'id_proof' | 'address_proof' | 'education' | 'experience' | 'other';
  url: string;
  uploadedAt: string;
  approvalStatus: 'pending' | 'approved' | 'rejected';
  approvedBy?: string;
  rejectionReason?: string;
}

interface LeaveRequest {
  id: string;
  employeeId: string;
  leaveType: 'sick' | 'casual' | 'annual' | 'maternity' | 'emergency';
  startDate: string;
  endDate: string;
  days: number;
  reason: string;
  status: 'pending' | 'approved' | 'rejected';
  appliedAt: string;
  approvedBy?: string;
  approvedAt?: string;
  rejectionReason?: string;
}

const EmployeeProfile = () => {
  const { user } = useAuth();
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('profile');
  const [documents, setDocuments] = useState<Document[]>([]);
  const [leaveRequests, setLeaveRequests] = useState<LeaveRequest[]>([]);
  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [showDocumentModal, setShowDocumentModal] = useState(false);

  const [profileData, setProfileData] = useState({
    name: user?.name || '',
    email: user?.email || '',
    phone: user?.phone || '',
    address: user?.address || '',
    emergencyContact: user?.emergencyContact || '',
    department: user?.department || '',
    joinDate: user?.joinDate || '',
    profileImage: user?.profileImage || ''
  });

  const [leaveFormData, setLeaveFormData] = useState({
    leaveType: 'casual' as const,
    startDate: '',
    endDate: '',
    reason: ''
  });

  const [documentFormData, setDocumentFormData] = useState({
    name: '',
    type: 'other' as const,
    file: null as File | null
  });




useEffect(() => {
  if (activeTab === 'documents') {
    loadDocuments();
  }
}, [activeTab]);

  //useEffect(() => {
   // if (user) {
      // loadDocuments();
      // loadLeaveRequests();
   // }
  //}, [user]);

  /*const loadDocuments = async () => {
    if (!user) return;
    try {
      const docs = await dbHelpers.getUserDocuments(user.id);
      setDocuments(docs);
    } catch (error) {
      console.error('Error loading documents:', error);
    }
  };*/



/*-----const loadDocuments = async () => {
  try {
    const res = await dbHelpers.getUserDocuments(user.id);

    console.log('API RESPONSE:', res);

    if (!res.status || !Array.isArray(res.data)) {
      setDocuments([]);
      return;
    }

    const mapped = res.data.map((d: any) => ({
      id: String(d.id),
      name: d.name,
      type: d.type || 'other',
      url: `http://localhost/backend/uploads/documents/${d.file_path}`,
      uploadedAt: d.created_at,
      approvalStatus: d.approval_status || 'pending',
      rejectionReason: d.rejection_reason || null
    }));

    setDocuments(mapped);
  } catch (e) {
    console.error(e);
    setDocuments([]);
  }
};*/










  const loadDocuments = async () => {
  if (!user) return;

  try {
    const res = await dbHelpers.getUserDocuments(user.id);

    console.log('Documents API:', res);

    const docs = res?.data?.documents || res?.data || [];

    if (Array.isArray(docs)) {
      setDocuments(
        docs.map((d: any) => ({
          id: String(d.id),
          name: d.original_name,
          type: d.doc_type || 'other',
          url: d.url,
          uploadedAt: d.created_at,
          approvalStatus: d.approval_status ?? 'pending',
          rejectionReason: d.rejection_reason ?? undefined,
        }))
      );
    } else {
      setDocuments([]);
    }
  } catch (error) {
    console.error('Error loading documents:', error);
    setDocuments([]);
  }
};








/*const loadDocuments = async () => {
  try {
    const res = await dbHelpers.getUserDocuments(user.id);

    if (!res.status || !Array.isArray(res.data)) {
      setDocuments([]);
      return;
    }

    const mapped = res.data.map((d: any) => {
      // 🔥 MOST IMPORTANT LINE
      const fileName =
        d.file_path || d.file || d.document || d.filename;

      if (!fileName) {
        console.error("FILE NAME MISSING 👉", d);
      }

      return {
        id: String(d.id),
        name: d.name,
        type: d.type || 'other',
        url: `http://localhost/backend/uploads/documents/${fileName}`,
        uploadedAt: d.created_at,
        approvalStatus: d.approval_status || 'pending',
        rejectionReason: d.rejection_reason || null
      };
    });

    setDocuments(mapped);
  } catch (e) {
    console.error(e);
    setDocuments([]);
  }
};*/








  const loadLeaveRequests = async () => {
    if (!user) return;
    try {
      const leaves = await dbHelpers.getUserLeaveRequests(user.id);
      setLeaveRequests(leaves);
    } catch (error) {
      console.error('Error loading leave requests:', error);
    }
  };

  const handleProfileUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!user) return;

    setLoading(true);
    try {
      await dbHelpers.updateUserProfile(user.id, {
        ...profileData,
        profile_update_status: 'pending' // Profile updates need admin approval
      });
      
      setIsEditing(false);
      alert('Profile updated successfully! Changes are pending admin approval.');
    } catch (error) {
      console.error('Error updating profile:', error);
      alert('Error updating profile. Please try again.');
    } finally {
      setLoading(false);
    }
  };







  /*const handleDocumentUpload = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!user || !documentFormData.file) return;

    setLoading(true);
    try {
      // In a real app, you would upload the file to a server
      // For demo, we'll simulate with a local URL
      const documentUrl = URL.createObjectURL(documentFormData.file);
      
      const newDocument: Document = {
        id: `doc-${Date.now()}`,
        name: documentFormData.name,
        type: documentFormData.type,
        url: documentUrl,
        uploadedAt: new Date().toISOString(),
        approvalStatus: 'pending'
      };

      await dbHelpers.uploadUserDocument(user.id, newDocument);
      await loadDocuments();
      
      setShowDocumentModal(false);
      setDocumentFormData({ name: '', type: 'other', file: null });
      alert('Document uploaded successfully! Pending admin approval.');
    } catch (error) {
      console.error('Error uploading document:', error);
      alert('Error uploading document. Please try again.');
    } finally {
      setLoading(false);
    }
  };
*/










/*const handleDocumentUpload = async (e: React.FormEvent) => {
  e.preventDefault();
  if (!user || !documentFormData.file) return;

  setLoading(true);
  try {
    const uploadRes = await dbHelpers.uploadFile(
      documentFormData.file,
      'document'
    );

    if (!uploadRes.status) {
      throw new Error(uploadRes.message || 'Upload failed');
    }

    // ✅ THIS IS MISSING
    await loadDocuments();

    setShowDocumentModal(false);
    setDocumentFormData({ name: '', type: 'other', file: null });

    alert('Document uploaded successfully!');
  } catch (err: any) {
    console.error(err);
    alert(err.message || 'Upload error');
  } finally {
    setLoading(false);
  }
};
*/







const handleDocumentUpload = async (e: React.FormEvent) => {
  e.preventDefault();
  if (!user || !documentFormData.file) return;

  setLoading(true);
  try {
    const formData = new FormData();
    formData.append('file', documentFormData.file);
    formData.append('name', documentFormData.name);
    formData.append('type', documentFormData.type);
    formData.append('userId', user.id);

    const uploadRes = await dbHelpers.uploadFile(formData);

    if (!uploadRes.status) {
      throw new Error(uploadRes.message || 'Upload failed');
    }

    await loadDocuments(); // ✅

    setShowDocumentModal(false);
    setDocumentFormData({ name: '', type: 'other', file: null });

    alert('Document uploaded successfully!');
  } catch (err: any) {
    console.error(err);
    alert(err.message || 'Upload error');
  } finally {
    setLoading(false);
  }
};










  

  const handleLeaveRequest = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!user) return;

    const startDate = new Date(leaveFormData.startDate);
    const endDate = new Date(leaveFormData.endDate);
    const days = Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;

    setLoading(true);
    try {
      const newLeaveRequest: LeaveRequest = {
        id: `leave-${Date.now()}`,
        employeeId: user.id,
        leaveType: leaveFormData.leaveType,
        startDate: leaveFormData.startDate,
        endDate: leaveFormData.endDate,
        days,
        reason: leaveFormData.reason,
        status: 'pending',
        appliedAt: new Date().toISOString()
      };

      await dbHelpers.createLeaveRequest(newLeaveRequest);
      await loadLeaveRequests();
      
      setShowLeaveModal(false);
      setLeaveFormData({ leaveType: 'casual', startDate: '', endDate: '', reason: '' });
      alert('Leave request submitted successfully!');
    } catch (error) {
      console.error('Error submitting leave request:', error);
      alert('Error submitting leave request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'approved': return 'text-green-600 bg-green-50';
      case 'rejected': return 'text-red-600 bg-red-50';
      case 'pending': return 'text-yellow-600 bg-yellow-50';
      default: return 'text-gray-600 bg-gray-50';
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'approved': return <CheckCircle className="h-4 w-4" />;
      case 'rejected': return <XCircle className="h-4 w-4" />;
      case 'pending': return <AlertCircle className="h-4 w-4" />;
      default: return <Clock className="h-4 w-4" />;
    }
  };

  if (!user) {
    return (
      <div className="text-center py-12">
        <User className="h-16 w-16 text-gray-400 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">Please Login</h3>
        <p className="text-gray-600">You need to login to access your profile.</p>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto p-6 space-y-8">
      {/* Header */}
      <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="w-16 h-16 bg-brand-primary rounded-full flex items-center justify-center text-white text-2xl font-bold">
              {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
            </div>
            <div>
              <h1 className="text-2xl font-bold text-brand-secondary">{user.name}</h1>
              <p className="text-gray-600">{user.department} • {user.role}</p>
              <p className="text-sm text-gray-500">Employee ID: {user.id}</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-500">Joined</p>
            <p className="font-medium">{new Date(user.joinDate).toLocaleDateString()}</p>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="bg-white rounded-xl shadow-lg border border-gray-200">
        <div className="border-b border-gray-200">
          <nav className="flex space-x-8 px-6">
            {[
              { id: 'profile', label: 'Profile', icon: User },
              { id: 'documents', label: 'Documents', icon: FileText },
              { id: 'leave', label: 'Leave Requests', icon: Calendar }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-2 border-b-2 font-medium text-sm flex items-center space-x-2 transition-colors duration-200 ${
                  activeTab === tab.id
                    ? 'border-brand-primary text-brand-primary'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              >
                <tab.icon className="h-4 w-4" />
                <span>{tab.label}</span>
              </button>
            ))}
          </nav>
        </div>

        <div className="p-6">
          {/* Profile Tab */}
          {activeTab === 'profile' && (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-brand-secondary">Profile Information</h2>
                <button
                  onClick={() => setIsEditing(!isEditing)}
                  className="bg-brand-primary text-white px-4 py-2 rounded-lg font-medium hover:bg-brand-dark transition-colors duration-200 flex items-center"
                >
                  <Edit3 className="h-4 w-4 mr-2" />
                  {isEditing ? 'Cancel' : 'Edit Profile'}
                </button>
              </div>

              <form onSubmit={handleProfileUpdate} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-brand-secondary mb-2">
                      Full Name
                    </label>
                    <div className="relative">
                      <User className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
                      <input
                        type="text"
                        value={profileData.name}
                        onChange={(e) => setProfileData(prev => ({ ...prev, name: e.target.value }))}
                        disabled={!isEditing}
                        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent disabled:bg-gray-50"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-brand-secondary mb-2">
                      Email Address
                    </label>
                    <div className="relative">
                      <Mail className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
                      <input
                        type="email"
                        value={profileData.email}
                        onChange={(e) => setProfileData(prev => ({ ...prev, email: e.target.value }))}
                        disabled={!isEditing}
                        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent disabled:bg-gray-50"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-brand-secondary mb-2">
                      Phone Number
                    </label>
                    <div className="relative">
                      <Phone className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
                      <input
                        type="tel"
                        value={profileData.phone}
                        onChange={(e) => setProfileData(prev => ({ ...prev, phone: e.target.value }))}
                        disabled={!isEditing}
                        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent disabled:bg-gray-50"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-brand-secondary mb-2">
                      Department
                    </label>
                    <div className="relative">
                      <Briefcase className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
                      <input
                        type="text"
                        value={profileData.department}
                        disabled
                        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg bg-gray-50"
                      />
                    </div>
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-brand-secondary mb-2">
                      Address
                    </label>
                    <div className="relative">
                      <MapPin className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
                      <textarea
                        value={profileData.address}
                        onChange={(e) => setProfileData(prev => ({ ...prev, address: e.target.value }))}
                        disabled={!isEditing}
                        rows={3}
                        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent disabled:bg-gray-50 resize-vertical"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-brand-secondary mb-2">
                      Emergency Contact
                    </label>
                    <div className="relative">
                      <Phone className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
                      <input
                        type="tel"
                        value={profileData.emergencyContact}
                        onChange={(e) => setProfileData(prev => ({ ...prev, emergencyContact: e.target.value }))}
                        disabled={!isEditing}
                        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent disabled:bg-gray-50"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-brand-secondary mb-2">
                      Join Date
                    </label>
                    <div className="relative">
                      <Calendar className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
                      <input
                        type="date"
                        value={profileData.joinDate}
                        disabled
                        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg bg-gray-50"
                      />
                    </div>
                  </div>
                </div>

                {isEditing && (
                  <div className="flex gap-4">
                    <button
                      type="submit"
                      disabled={loading}
                      className="bg-brand-primary text-white py-3 px-6 rounded-lg font-semibold hover:bg-brand-dark transition-colors duration-200 flex items-center disabled:opacity-50"
                    >
                      {loading ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                          Saving...
                        </>
                      ) : (
                        <>
                          <Save className="h-5 w-5 mr-2" />
                          Save Changes
                        </>
                      )}
                    </button>
                  </div>
                )}
              </form>
            </div>
          )}

          {/* Documents Tab */}
          {activeTab === 'documents' && (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-brand-secondary">Documents</h2>
                <button
                  onClick={() => setShowDocumentModal(true)}
                  className="bg-brand-primary text-white px-4 py-2 rounded-lg font-medium hover:bg-brand-dark transition-colors duration-200 flex items-center"
                >
                  <Plus className="h-4 w-4 mr-2" />
                  Upload Document
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {documents.map((doc) => (
                  <div key={doc.id} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-center">
                        <FileText className="h-8 w-8 text-brand-primary mr-3" />
                        <div>
                          <h3 className="font-medium text-brand-secondary">{doc.name}</h3>
                          <p className="text-sm text-gray-500 capitalize">{doc.type.replace('_', ' ')}</p>
                        </div>
                      </div>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium flex items-center ${getStatusColor(doc.approvalStatus)}`}>
                        {getStatusIcon(doc.approvalStatus)}
                        <span className="ml-1 capitalize">{doc.approvalStatus}</span>
                      </span>
                    </div>
                    <p className="text-xs text-gray-500 mb-3">
                      Uploaded: {new Date(doc.uploadedAt).toLocaleDateString()}
                    </p>
                    <div className="flex gap-2">
                      <button
  onClick={() => window.open(doc.url, '_blank')}
  className="flex-1 bg-brand-primary text-white py-2 px-3 rounded text-sm"
>
  <Eye className="h-4 w-4 mr-1" />
  View
</button>

<button
  onClick={() => window.location.href = doc.url}
  className="flex-1 bg-gray-200 text-gray-700 py-2 px-3 rounded text-sm"
>
  <Download className="h-4 w-4 mr-1" />
  Download
</button>

                    </div>
                    {doc.rejectionReason && (
                      <div className="mt-3 p-2 bg-red-50 rounded border-l-4 border-red-400">
                        <p className="text-sm text-red-800">
                          <strong>Rejection Reason:</strong> {doc.rejectionReason}
                        </p>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {documents.length === 0 && (
                <div className="text-center py-12">
                  <FileText className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                  <h3 className="text-lg font-medium text-gray-900 mb-2">No documents uploaded</h3>
                  <p className="text-gray-600 mb-4">Upload your documents for verification and approval.</p>
                  <button
                    onClick={() => setShowDocumentModal(true)}
                    className="bg-brand-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-brand-dark transition-colors duration-200"
                  >
                    Upload First Document
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Leave Requests Tab */}
          {activeTab === 'leave' && (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-brand-secondary">Leave Requests</h2>
                <button
                  onClick={() => setShowLeaveModal(true)}
                  className="bg-brand-primary text-white px-4 py-2 rounded-lg font-medium hover:bg-brand-dark transition-colors duration-200 flex items-center"
                >
                  <Plus className="h-4 w-4 mr-2" />
                  Request Leave
                </button>
              </div>

              <div className="space-y-4">
                {leaveRequests.map((leave) => (
                  <div key={leave.id} className="bg-gray-50 rounded-lg p-6 border border-gray-200">
                    <div className="flex items-start justify-between mb-4">
                      <div>
                        <h3 className="font-semibold text-brand-secondary capitalize">
                          {leave.leaveType} Leave
                        </h3>
                        <p className="text-sm text-gray-600">
                          {new Date(leave.startDate).toLocaleDateString()} - {new Date(leave.endDate).toLocaleDateString()}
                        </p>
                        <p className="text-sm text-gray-500">{leave.days} day(s)</p>
                      </div>
                      <span className={`px-3 py-1 rounded-full text-sm font-medium flex items-center ${getStatusColor(leave.status)}`}>
                        {getStatusIcon(leave.status)}
                        <span className="ml-1 capitalize">{leave.status}</span>
                      </span>
                    </div>
                    <div className="mb-4">
                      <p className="text-sm font-medium text-gray-700 mb-1">Reason:</p>
                      <p className="text-sm text-gray-600">{leave.reason}</p>
                    </div>
                    <div className="text-xs text-gray-500">
                      Applied: {new Date(leave.appliedAt).toLocaleDateString()}
                      {leave.approvedAt && (
                        <span className="ml-4">
                          Approved: {new Date(leave.approvedAt).toLocaleDateString()}
                        </span>
                      )}
                    </div>
                    {leave.rejectionReason && (
                      <div className="mt-3 p-3 bg-red-50 rounded border-l-4 border-red-400">
                        <p className="text-sm text-red-800">
                          <strong>Rejection Reason:</strong> {leave.rejectionReason}
                        </p>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {leaveRequests.length === 0 && (
                <div className="text-center py-12">
                  <Calendar className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                  <h3 className="text-lg font-medium text-gray-900 mb-2">No leave requests</h3>
                  <p className="text-gray-600 mb-4">You haven't submitted any leave requests yet.</p>
                  <button
                    onClick={() => setShowLeaveModal(true)}
                    className="bg-brand-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-brand-dark transition-colors duration-200"
                  >
                    Request Your First Leave
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Document Upload Modal */}
      {showDocumentModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-brand-secondary">Upload Document</h3>
              <button onClick={() => setShowDocumentModal(false)} className="text-gray-500 hover:text-gray-700">
                <XCircle className="h-6 w-6" />
              </button>
            </div>

            <form onSubmit={handleDocumentUpload} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-brand-secondary mb-2">
                  Document Name
                </label>
                <input
                  type="text"
                  value={documentFormData.name}
                  onChange={(e) => setDocumentFormData(prev => ({ ...prev, name: e.target.value }))}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                  placeholder="Enter document name"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-brand-secondary mb-2">
                  Document Type
                </label>
                <select
                  value={documentFormData.type}
                  onChange={(e) => setDocumentFormData(prev => ({ ...prev, type: e.target.value as any }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                >
                  <option value="resume">Resume/CV</option>
                  <option value="id_proof">ID Proof</option>
                  <option value="address_proof">Address Proof</option>
                  <option value="education">Education Certificate</option>
                  <option value="experience">Experience Letter</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-brand-secondary mb-2">
                  Upload File
                </label>
                <input
                  type="file"
                  onChange={(e) => setDocumentFormData(prev => ({ ...prev, file: e.target.files?.[0] || null }))}
                  required
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Supported formats: PDF, DOC, DOCX, JPG, PNG (Max 5MB)
                </p>
              </div>

              <div className="flex gap-3">
                <button
                  type="submit"
                  disabled={loading}
                  className="flex-1 bg-brand-primary text-white py-3 px-4 rounded-lg font-semibold hover:bg-brand-dark transition-colors duration-200 disabled:opacity-50"
                >
                  {loading ? 'Uploading...' : 'Upload Document'}
                </button>
                <button
                  type="button"
                  onClick={() => setShowDocumentModal(false)}
                  className="px-4 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors duration-200"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Leave Request Modal */}
      {showLeaveModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-brand-secondary">Request Leave</h3>
              <button onClick={() => setShowLeaveModal(false)} className="text-gray-500 hover:text-gray-700">
                <XCircle className="h-6 w-6" />
              </button>
            </div>

            <form onSubmit={handleLeaveRequest} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-brand-secondary mb-2">
                  Leave Type
                </label>
                <select
                  value={leaveFormData.leaveType}
                  onChange={(e) => setLeaveFormData(prev => ({ ...prev, leaveType: e.target.value as any }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                >
                  <option value="casual">Casual Leave</option>
                  <option value="sick">Sick Leave</option>
                  <option value="annual">Annual Leave</option>
                  <option value="maternity">Maternity Leave</option>
                  <option value="emergency">Emergency Leave</option>
                </select>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-brand-secondary mb-2">
                    Start Date
                  </label>
                  <input
                    type="date"
                    value={leaveFormData.startDate}
                    onChange={(e) => setLeaveFormData(prev => ({ ...prev, startDate: e.target.value }))}
                    required
                    min={new Date().toISOString().split('T')[0]}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-brand-secondary mb-2">
                    End Date
                  </label>
                  <input
                    type="date"
                    value={leaveFormData.endDate}
                    onChange={(e) => setLeaveFormData(prev => ({ ...prev, endDate: e.target.value }))}
                    required
                    min={leaveFormData.startDate || new Date().toISOString().split('T')[0]}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-brand-secondary mb-2">
                  Reason for Leave
                </label>
                <textarea
                  value={leaveFormData.reason}
                  onChange={(e) => setLeaveFormData(prev => ({ ...prev, reason: e.target.value }))}
                  required
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent resize-vertical"
                  placeholder="Please provide a detailed reason for your leave request..."
                />
              </div>

              <div className="flex gap-3">
                <button
                  type="submit"
                  disabled={loading}
                  className="flex-1 bg-brand-primary text-white py-3 px-4 rounded-lg font-semibold hover:bg-brand-dark transition-colors duration-200 disabled:opacity-50"
                >
                  {loading ? 'Submitting...' : 'Submit Request'}
                </button>
                <button
                  type="button"
                  onClick={() => setShowLeaveModal(false)}
                  className="px-4 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors duration-200"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployeeProfile;